<template>
  <main>
    <div class="clearfix flex flex-wrap justify-start items-center">
      <div class="col-4 px0 mr1" v-for="image in project.images" :key="toString(image.id)">
        <b-img v-if="image.image" :src="image.image.replace('&rotate=180', '').replace('&rotate=270', '').replace('&rotate=90', '').replace('&rotate=0', '')" fluid></b-img>
        <b-alert show variant="primary">
        <p class="hide" v-if="image.isPrimary === true">{{primaryselected = image.id.toString()}}</p>
          <b-form-radio size="lg" v-model="primaryselected" :name="project.projectid.toString()" @change="change_position(image.id,project.projectid)" :id="image.id.toString()" :value="image.id.toString()" class=" mr-1" :checked="image.isPrimary === true">
            Primært billede
          </b-form-radio>
        </b-alert>
        <div class="flex justify-start items-center">
          <b-button @click="rotate_image(image.id,project.projectid,image.image)"  variant="outline-dark" class="border-0 ">
            <i class="el-icon-refresh-right" aria-hidden="true"></i>
          </b-button>
          <b-button @click="delete_image(image.id,project.projectid)" class="white-button border-none not-rounded">
            <i class="el-icon-delete" aria-hidden="true"></i>
          </b-button>
        </div>
      </div>
    </div>
    <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
  </main>
</template>
<script>
import Dropzone from 'vue2-dropzone'
export default {
  name: 'profileimages',
  props: ['project'],
  components: {
    Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 py4 flex flex-column justify-center items-center" style="height:100%;border:1px dashed #0B3645;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="40" height="40" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:18px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:15px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      primaryselected: ''
    }
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  // mounted () {
  //   this.project.images.forEach(a => {
  //     if (a.isPrimary) {
  //       this.primaryselected = a.id.toString()
  //     }
  //   })
  // },
  methods: {
    'showSuccess': function (file) {
      this.$emit('Reload')
    },
    toString (value) {
      return value.toString()
    },
    change_position (imageId, projectid) {
      this.$emit('moveImage', imageId, projectid)
    },
    delete_image (imageId, projectid) {
      this.$emit('delete_image', imageId, projectid)
    },
    rotate_image (imageId, projectid, image) {
      var primary = ''
      for (var id in this.project.images) {
        var val = this.project.images[id]
        if (val.isPrimary) {
          primary = val.id
        }
      }
      this.$emit('rorate_image', imageId, projectid, image, primary)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('projectid', this.project.projectid)
      formData.append('operation', 'uploadImagesProject')
    }
  }
}
</script>
<style lang="less">
.custom-control-input {
  position: unset;
  z-index: 1;
  opacity: 1;
  margin-right: 14px;
}
.vue-dropzone {
  width:100%;
  padding: 0;
  border: 0;
  background: white;
  &:hover {
    background: white;
  }
}
.dz-preview {
  display: none!important;
  }
  .alert {
    border-radius: 0rem !important;
  }
</style>



// WEBPACK FOOTER //
// projectimages.vue?adfafe18